module.exports = __webpack_public_path__ + "img/cc_visa.571b9b41.svg";